import { z } from 'zod';
export const ThemePreferenceSchema = z.enum(['match_telegram', 'light', 'dark']);
export const AppLocaleSchema = z.enum(['en', 'ru', 'uz']);
